module.exports = __webpack_public_path__ + "static/media/Максимов В.П. (ДУ).d19c2ead.pdf";